import { useState } from 'react';
import { Avatar, Tooltip, Button } from 'antd';
import { UserOutlined, CloseOutlined } from '@ant-design/icons';
import './GroupCompanyCreate.less';

export const GroupCompanyCreate = (props) => {
  const { listPeople, removeItem } = props;
  const [showAll, setShowAll] = useState(false);
  return (
    <>
      <div className='group-people-create scroller'>
        {showAll
          ? listPeople?.map((item, index) => {
              return (
                <Tooltip title={item.companyName} key={index}>
                  <div className='group-people-create__avatar-wrapper'>
                    <Avatar
                      key={index}
                      className='group-people-create__avatar'
                      src={item?.logo}
                      icon={<UserOutlined />}
                      size={60}
                    />

                    <Button
                      shape='circle'
                      onClick={() => removeItem(item.companyId)}
                      icon={<CloseOutlined />}
                      className='group-people-create__avatar-remove'
                      size='small'
                    />
                  </div>
                </Tooltip>
              );
            })
          : listPeople?.map((item, index) => {
              if (index <= 5)
                return (
                  <Tooltip title={item.companyName}>
                    <div className='group-people-create__avatar-wrapper'>
                      <Avatar
                        key={index}
                        className='group-people-create__avatar'
                        src={item?.logo}
                        icon={<UserOutlined />}
                        size={60}
                      />

                      <Button
                        shape='circle'
                        onClick={() => removeItem(item.companyId)}
                        icon={<CloseOutlined />}
                        className='group-people-create__avatar-remove'
                        size='small'
                      />
                    </div>
                  </Tooltip>
                );
            })}

        {listPeople?.length > 6 && !showAll && (
          <div
            className=' group-people-create__see-more'
            onClick={() => setShowAll(true)}
          >
            ... {listPeople?.length - 6} more
          </div>
        )}
        {listPeople?.length >= 6 && showAll && (
          <div
            className=' group-people-create__see-more'
            onClick={() => setShowAll(false)}
          >
            Show less
          </div>
        )}
      </div>
    </>
  );
};

export default GroupCompanyCreate;
